/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Presentation_Template_Upload_MasterInputs */



/**
* | output |
* | --- |
* | "Upload PowerPoint template" |
*
* @param {Presentation_Template_Upload_MasterInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const presentation_template_upload_master = /** @type {((inputs?: Presentation_Template_Upload_MasterInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Presentation_Template_Upload_MasterInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("PowerPoint-Vorlage hochladen")
	return /** @type {LocalizedString} */ ("Upload PowerPoint template")
});